// Adding this much (or more) to the balance earns a bonus of BONUS_RATE extra funds.
export const BONUS_THRESHOLD = 500;
export const BONUS_RATE = 0.1;
export const BONUS_LABEL = "+10% bonus";

// Bonus funds granted on top of the amount added (0 below the threshold).
export const getBonusFunds = (amount) =>
   amount >= BONUS_THRESHOLD ? Math.floor(amount * BONUS_RATE) : 0;

// Preset top-up amounts (in USD) shown in the "Add funds" modal. `funds` is the
// value POSTed to the /Credits/pay endpoint (the backend request field is still
// `credits`); with dollar pricing it is the dollar amount added to the balance
// (and charged to the card).
export const fundPackages = [
   { id: "funds-1", funds: 1 },
   { id: "funds-10", funds: 10 },
   { id: "funds-20", funds: 20 }
];

// The two screens of the buy-funds flow: pick a package, then pay.
export const BUY_STEP = Object.freeze({
   PACKAGE: "package",
   PAYMENT: "payment"
});

// Whether the payment step charges a saved card or collects a new one.
export const PAYMENT_MODE = Object.freeze({
   SAVED: "saved",
   NEW: "new"
});
